import { createContext } from 'react';

export interface AuthInformation {
    readonly sessionId: string;
    readonly name: string;
    readonly isLoggedIn: boolean;
}

export interface AuthChangeOptions {
  signOut: () => void;
}

export type AuthInformationContext = AuthInformation & AuthChangeOptions;


export const AuthContext = createContext<AuthInformationContext>({} as AuthInformationContext);